// Типы экшенов
export enum AuthType {
	SET_AUTH = 'SET_AUTH',
	SET_AUTH_USER = 'SET_AUTH_USER',
	AUTHORIZE = 'AUTHORIZE',
	LOGOUT = 'LOGOUT',
	LOGIN = 'LOGIN',
	REFRESH = 'REFRESH'
}

// Тип для пользователя
export interface IUser {
	roleId: number | null
	id: number
	firstname: string
	lastname: string
}

// --- Экшен-криейторы ---

export const login = (login: string, password: string) => ({
	type: AuthType.LOGIN as const,
	login,
	password,
})

export const authorize = () => ({
	type: AuthType.AUTHORIZE as const,
})

export const logout = () => ({
	type: AuthType.LOGOUT as const,
})

export const setAuth = (access_token: string, expires_in: number, refresh_token: string) => ({
	type: AuthType.SET_AUTH as const,
	access_token,
	expires_in,
	refresh_token
})

export const setAuthUser = (user: IUser) => ({
	type: AuthType.SET_AUTH_USER as const,
	user,
})

export const refresh = () => ({
	type: AuthType.REFRESH as const,
})

// --- Общий тип экшенов (используется в редьюсере) ---

export type AuthActions =
	| ReturnType<typeof login>
	| ReturnType<typeof authorize>
	| ReturnType<typeof logout>
	| ReturnType<typeof setAuth>
	| ReturnType<typeof setAuthUser>
	| ReturnType<typeof refresh>
